import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Reveal from './Reveal';

const objections = [
  {
    q: '“We already use spreadsheets.”',
    a: 'Keep them. Import once, and the sheet stops being the only copy that’s current.',
  },
  {
    q: '“Our buyers won’t switch.”',
    a: 'They don’t have to. Share your menu by link, and you can let buyers look before they sign up.',
  },
  {
    q: '“Our data is confidential.”',
    a: 'Then it stays that way. Nothing public, and supplier identity is never shown.',
  },
  {
    q: '“We don’t need another notification firehose.”',
    a: 'Neither do we. Sends are rate-limited, alerts collapse into one digest, and every email unsubscribes in a click.',
  },
  {
    q: '“Is this Tamerlane’s tool?”',
    a: 'Tamerlane, the brokerage our co-founder Jhavid founded, is a customer like any other. It sees only the menus shared with it, and only the buyers it brings on itself.',
  },
  {
    q: '“We already use other sales and ordering software.”',
    a: 'Keep it. Cannafax handles the bulk trade alongside it, not instead of it.',
  },
  {
    q: '“I don’t have time to load inventory.”',
    a: 'Forward the email you already send to ingest@cannafax.ai, or upload your spreadsheet. No template, no retyping.',
  },
  {
    q: '“Can other sellers’ buyers see my menus?”',
    a: 'No. Every menu goes only to the buyers and brokers you choose, and a listing can be resold only with your approval.',
  },
  {
    q: '“My partner has to see it first.”',
    a: 'Book a short demo together, or send them this page.',
  },
  {
    q: '“What happens after launch?”',
    a: 'We’re launching soon, and every plan is free until then. After launch, new sign-ups get their first 30 days free before billing starts. Buyers stay free, always.',
  },
];

const ObjectionStrip = () => (
  <section className="border-b border-border bg-background py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">The questions we hear on every call.</h2>
      </Reveal>

      <dl className="mt-10 divide-y divide-border border-t border-border">
        {objections.map((o, i) => (
          <Reveal key={o.q} delay={i * 80}>
            <div className="grid gap-2 py-6 md:grid-cols-5 md:gap-8">
              <dt className="font-medium md:col-span-2">{o.q}</dt>
              <dd className="text-muted-foreground md:col-span-3">{o.a}</dd>
            </div>
          </Reveal>
        ))}
      </dl>

      <Reveal className="mt-10">
        <Button asChild size="lg" className="bg-brand text-brand-foreground hover:bg-brand/90">
          <Link to="/auth?mode=signup">
            Build your first menu free
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </Reveal>
    </div>
  </section>
);

export default ObjectionStrip;